export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Regular.452bf157.woff2";